import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { User } from 'app/core/user/user.types';
import { Note, NoteFormData } from './note-state/note.model';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);


  getNotes() {
    return this._httpClient.get(`${this._apiUrl}/v1/notes/get-all-notes`);
  }

  createNote(note: NoteFormData) {
    return this._httpClient.post(`${this._apiUrl}/v1/notes/create-note`, note);
  }

  markNoteAsRead(noteId: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/notes/mark-read/${noteId}`);
  }

  updateNote(note: Note) {
    return this._httpClient.put(`${this._apiUrl}/v1/notes/update-note/${note._id}/${note.md5Checksum}`, note);
  }

  deleteNote(noteId: string) {
    return this._httpClient.delete(`${this._apiUrl}/v1/notes/delete-note/${noteId}`);
  }

  getFilteredNotes(filter: any) {
    return this._httpClient.get(`${this._apiUrl}/v1/notes/get-filtered-notes`, { params: filter });
  }

  getFilteredUsers(filter: any) {
    return this._httpClient.get<User[]>(`${this._apiUrl}/v1/users/filtered-users`, { params: filter });
  }

  getAllUsers() {
    return this._httpClient.get(`${this._apiUrl}/v1/users/get-all`);
  }

}
